module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-container"
  }, [_c('main-toolbar', {
    attrs: {
      "mode": "about"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-content"
  }, [_c('div', {
    staticClass: "background-image"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 18,
      "lg": 12
    }
  }, [_c('about-portrait', {
    attrs: {
      "filter-by": _vm.filterBy
    },
    on: {
      "update:filterBy": function($event) {
        _vm.filterBy = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.resume), function(section) {
    return _c('el-card', {
      key: section.id,
      staticClass: "about-section"
    }, [_c('div', {
      staticClass: "section-title"
    }, [_vm._v("\n            " + _vm._s(section.label) + "\n          ")]), _vm._v(" "), _c('el-collapse', _vm._l((section.content), function(item) {
      return (!_vm.filterBy || (_vm.filterBy && (_vm.filterBy === 'all' || item.topic.indexOf(_vm.filterBy) >= 0))) ? _c('el-collapse-item', {
        key: item.id
      }, [_c('template', {
        slot: "title"
      }, [_c('span', {
        staticClass: "section-item-label"
      }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")]), _vm._v(" "), _c('span', {
        staticClass: "hidden-sm-and-down resume-section-item-at"
      }, [_c('a', {
        attrs: {
          "href": item.link
        }
      }, [_vm._v(_vm._s(item.at))])]), _vm._v(" "), (item.time && item.duration) ? _c('span', {
        staticClass: "hidden-sm-and-down resume-section-item-time"
      }, [_vm._v("\n                  " + _vm._s(item.time) + " • " + _vm._s(item.duration) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('el-row', {
        staticClass: "hidden-md-and-up resume-section-item-at-time-mobile"
      }, [_c('span', {
        staticClass: "hidden-md-and-up resume-section-item-at"
      }, [_c('a', {
        attrs: {
          "href": item.link
        }
      }, [_vm._v(_vm._s(item.at))])]), _vm._v(" "), (item.time && item.duration) ? _c('span', {
        staticClass: "resume-section-item-time"
      }, [_vm._v("\n                  " + _vm._s(item.time) + " • " + _vm._s(item.duration) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('resume-section-item', {
        attrs: {
          "content": item.content
        }
      })], 2) : _vm._e()
    }))], 1)
  }), _vm._v(" "), _c('el-card', {
    staticClass: "about-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("\n            More About Me\n          ")]), _vm._v(" "), _c('el-row', {
    staticClass: "social-media"
  }, [_c('el-button', {
    attrs: {
      "circle": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/jae-hyun-choe-8693b83b/",
      "role": "button",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/social-media-logo-linkedin.svg")
    }
  })])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "circle": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/choejaehyun",
      "role": "button",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/social-media-logo-facebook.svg")
    }
  })])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "circle": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/choe_jaehyun/",
      "role": "button",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/social-media-logo-instagram.svg")
    }
  })])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "circle": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UC4UqN1QOEYDGr9rTMhIM-Aw",
      "role": "button",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/social-media-logo-youtube.svg")
    }
  })])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "circle": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://plus.google.com/u/0/+JaeHyunChoe",
      "role": "button",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/social-media-logo-googleplus.svg")
    }
  })])])], 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7125ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/about.vue
// module id = 283
// module chunks = 0